import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import SourceURLField from '../../form-fields/upload/source-url'
import { CreationToolUploadContext } from '../manager'

const SourceURL = styled(SourceURLField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadSourceURLField = ({ className, field, sourceId }: Props) => {
    const { sourceUrl, setSourceUrl, uploadSources, updateUploadSource } = useContext(CreationToolUploadContext)
    const [displaySourceUrl, setDisplaySourceUrl] = useState<string>('')

    useEffect(() => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && setDisplaySourceUrl(source.sourceUrl || '')
        } else {
            setDisplaySourceUrl(sourceUrl)
        }
    }, [uploadSources, sourceId, sourceUrl, setDisplaySourceUrl])

    const onChange = (url: string) => {
        if (sourceId) {
            const source = uploadSources.find(src => src.id === sourceId)
            source && updateUploadSource({ ...source, sourceUrl: url })
        } else {
            setSourceUrl(url)
        }
    }

    return (
        <SourceURL
            {...{
                className,
                field,
                onChange,
                sourceUrl: displaySourceUrl,
                showInstructions: true,
                ignoreCTA: !!sourceId,
            }}
        />
    )
}

export default CreationUploadSourceURLField
